/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/base-teaser-tile.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';

export const FullTeaserTileFragment = gql`
  ${BaseTeaserTileFragment}
  ${IconFragment}
  ${ImageFragment}

  fragment FullTeaserTileFragment on TeaserTile {
    ...BaseTeaserTileFragment

    image {
      ...ImageFragment
    }
    overlayIcon {
      ...IconFragment
    }
    descriptionCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
  }
`;
